import React, { memo } from 'react';

import { useOverlayState } from '../../../../hooks/useOverlayState';

import ScenarioCard from '../ScenarioCard/ScenarioCard';
import SectionContainer from '../SectionContainer/SectionContainer';
import CreateScenarioModal from '../CreateScenarioModal/CreateScenarioModal';
import { Button } from '../../../../design-system';
import { FlowChartIcon } from '../../../../design-system/Icons';

const ScenariosTab = ({ playbookDetail, setPlaybookDetail, isEditable }) => {
    const { id, name, scenarios } = playbookDetail;

    const {
        isOpened: isCreateScenarioModalOpened,
        open: openCreateScenarioModal,
        close: closeCreateScenarioModal,
    } = useOverlayState();

    const areScenarios = !!scenarios?.length;

    const renderButton = () => (
        <Button
            type="secondary"
            size="xs"
            text="New Scenario"
            leadingIcon={FlowChartIcon}
            onClick={openCreateScenarioModal}
        />
    );

    return (
        <SectionContainer
            title="Scenarios"
            description="Run agents inside of a playbook project"
            isEditable={isEditable}
            renderButton={renderButton}
        >
            {areScenarios && (
                <ul className="flex flex-col gap-3">
                    {scenarios.map((scenario) => (
                        <ScenarioCard
                            key={scenario.id}
                            scenario={scenario}
                            isEditable={isEditable}
                            setPlaybookDetail={setPlaybookDetail}
                        />
                    ))}
                </ul>
            )}

            {!areScenarios && (
                <p className="font-body-bold text-body-bold-s text-neutral-400">
                    No scenarios found
                </p>
            )}

            {isCreateScenarioModalOpened && (
                <CreateScenarioModal
                    playbookData={{ id, name }}
                    onClose={closeCreateScenarioModal}
                />
            )}
        </SectionContainer>
    );
};

export default memo(ScenariosTab);
